<template>
  <el-form label-position="top" :model="form" :rules="rules" ref="form_create">
    <el-form-item
      style="margin-top: 30px; font-weight: bold"
      label="Nombre del archivo"
      prop="folderName"
    >
      <el-input
        v-model="form.folderName"
        placeholder="Escribir el nombre del archivo"
        class="fields"
      ></el-input>
    </el-form-item>

    <el-form-item
      style="margin-top: 30px; font-weight: bold"
      label="Tipo de Documento"
      prop="DocumentType"
    >
      <el-select
        v-model="form.DocumentType"
        placeholder="Tipo de Documento"
        style="width: 100%"
      >
        <el-option
          v-for="item in DocumentTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      label="Departamento"
      style="margin-top: 30px; font-weight: bold"
      prop="departmentselected"
    >
      <el-select
        v-model="form.departmentselected"
        placeholder="Seleccion de departamento"
        filterable
        style="width: 100%"
      >
        <el-option
          v-for="(department, index) in departmentList"
          :key="index"
          :value="department.ID"
          :label="department.Name"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="Adjuntar documento" style="font-weight: bold">
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :drag="true"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        :file-list="fileList"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :on-error="handleError"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos con un tamaño menor de 4MG
        </div>
      </el-upload>
    </el-form-item>
    <el-button @click="onCancel" size="mini">Cancel</el-button>
    <el-button id="btnSave" type="primary" size="mini" @click="saveDocument"
      >Guardar</el-button
    >
  </el-form>
</template>
<script>
export default {
  name: "CreateDocumentOurCompany",
  props: {
    Visible: {
      type: Boolean,
      default: false
    },
    tabFrom: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isEnabled: true,
      fileList: [],
      departmentList: [],
      form: {
        folderName: "",
        DocumentType: this.tabFrom === "cir" ? "cir" : "",
        departmentselected: "",
        //  AttachmentUrl: this.fileList.Name,
        CreatedBy: this.$store.state.user.user.UserID,
        CompanyCode: this.$store.state.user.user.CompanySelected,
        fileListResponse: []
      },
      rules: {
        folderName: [{ required: true, trigger: "blur", message: "Requerido" }],
        departmentselected: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        DocumentType: [
          { required: true, trigger: "blur", message: "Requerido" }
        ]
      },
      categoriesValue: [],
      count: 0
    };
  },
  mounted() {
    this.getDepartments();
  },
  computed: {
    /*
    document_type() {
      return  this.tabFrom === "cir" ? "cir" : ""
    },
    */
    totalUploadFiles() {
      return this.$refs.uploadFile.uploadFiles.length;
    },
    DocumentTypes() {
      let documentype;
      if (this.tabFrom === "cir") {
        documentype = [
          {
            value: "cir",
            label: "Circulares"
          }
        ];
        //this.setingDocumentTypeDefault()
      } else {
        documentype = [
          {
            value: "pol",
            label: "Políticas"
            //disabled: true
          },
          {
            value: "proc",
            label: "Procedimientos"
          },
          {
            value: "for",
            label: "Formularios"
          },
          {
            value: "mem",
            label: "Memorándum"
          }
        ];
      }
      return documentype;
    }
  },
  methods: {
    /*
    setingDocumentTypeDefault() {
      this.form.DocumentType = "cir"
    },
    */
    onCancel() {
      this.fileList = [];
      //this.$refs.uploadFile.uploadFiles = [];
      this.form = {};
      this.$emit("dialog-closed");
      this.$refs.form_create.resetFields();
    },
    saveDocument() {
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          this.$refs.uploadFile.submit();
        } else {
          return false;
        }
      });
    },
    handleUploadOnSuccess(response) {
      this.isEnabled = false;
      const items_count = response.length;
      for (var index = 0; index < items_count; index++) {
        if (items_count > 0) {
          this.fileList.push({
            name: response[index].Name,
            url: response[index].Url
          });
        }
      }
      //this.$refs.uploadFile.uploadFiles = [];
      this.count++;
      this.saves();
    },
    handleError(/*err, file, fileList*/) {
      //console.log(err, file, fileList);
    },
    saves() {
      let self = this;
      self.fileList.forEach((listFiles) => {
        if (this.count === this.totalUploadFiles) {
          self.form.fileListResponse = self.fileList;
          var params = {
            AttachmentUrl: listFiles.url,
            modulo: "OurCompany",
            AttachmentFileName: listFiles.name,
            CompanyCode: this.$store.state.user.user.CompanySelected,
            moduleId: 10,
            DepId: this.form.departmentselected,
            folderName: this.form.folderName,
            DocType: this.form.DocumentType,
            CreatedBy: this.$store.state.user.user.UserID
          };
          self.$http
            .post("/api/Folder/AddDocumentDevelopment", params)
            .then(() => {
              self.$emit("dialog-closed");
              self.$message({
                type: "success",
                message: "Archivo Agregado correctamente"
              });

              self.$emit("success");
            })
            .catch((err) => {
              self.$message({ type: "error", message: err.message });
              console.error("error");
            })
            .finally(() => {
              // self.count = 0;
              self.form = {};
              self.fileList = [];
              self.$refs.form_create.resetFields();
            });
        }
      });
    },
    async getDepartments() {
      const params = {
        params: {
          companyId: this.currentCompany,
          isEne: true
        }
      };
      this.$http
        .get("/api/deparments/all2", params)
        .then((resp) => {
          //console.log("Response: " , resp)
          this.departmentList = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  },
  watch: {
    Visible(val) {
      this.form = {};
      if (!val) this.fileList = []; //this.$refs.uploadFile.uploadFiles = [];
    },
    tabFrom(val) {
      let documentype;
      if (val === "cir") {
        documentype = this.DocumentTypes.filter((d) => d.value === val);
        this.DocumentTypes = documentype;
      }
    }
  }
};
</script>
<style scoped>
.title {
  /* Nuevo Documento */

  position: absolute;
  width: 143px;
  height: 19px;
  left: 20px;
  top: 52px;

  margin-left: 35%;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  color: #2484c4;
}

label .el-form-item__label {
  /* Adjuntar documento */

  width: 188px;
  height: 18px;

  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;

  color: #3c3c3c;
}

label {
  color: #bf3636;
  margin-top: 5px;
  margin-bottom: 5px;
}
ul > li > label > .el-upload-list--picture .el-upload-list__item-status-label {
  position: absolute;
  right: -17px;
  top: -7px;
  width: 46px;
  height: 26px;
  background: #5f8fdf;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 1px 1px #ccc;
}
</style>
